export class Machinetype
{
    id: number;
    type: string;
    imageurl : string;
}